<template>
  <v-main>
    <v-btn-toggle v-model="toggle_exclusive" mandatory style="width:100%;">
      <v-col fluid cols="12" class="pr-5">
        <v-row class="my-2">
          <v-btn
            :color="col[0]"
            :value="1"
            class="rounded-xl black--text text-capitalize"
            style="font-size:0.7vw; border: 1px solid black;"
            depressed
            width="100%"
            @click="sw(0)"
            max-height="35"
          >
            <v-row>
              <v-col align="start">Все сообщения</v-col>
            </v-row>
          </v-btn>
        </v-row>
        <v-row class="my-2">
          <v-btn
            :color="col[1]"
            :value="2"
            class="rounded-xl black--text text-capitalize"
            style="font-size:0.7vw;  border: 1px solid black;"
            depressed
            width="100%"
            @click="sw(1)"
            max-height="35"
          >
            <v-row>
              <v-col align="start">Новые</v-col>
            </v-row>
          </v-btn>
        </v-row>
        <v-row class="my-2">
          <v-btn
            :color="col[2]"
            :value="3"
            class="rounded-xl black--text text-capitalize"
            style="font-size:0.7vw;  border: 1px solid black;"
            depressed
            width="100%"
            @click="sw(2)"
            max-height="35"
          >
            <v-row>
              <v-col cols="9" align="start">Непрочитанные</v-col>
            </v-row>
          </v-btn>
        </v-row>
        <v-row class="my-2">
          <v-btn
            :color="col[3]"
            :value="4"
            class="rounded-xl black--text text-capitalize"
            style="font-size:0.7vw;  border: 1px solid black;"
            depressed
            width="100%"
            @click="sw(3)"
            max-height="35"
          >
            <v-row>
              <v-col align="start">Важные</v-col>
            </v-row>
          </v-btn>
        </v-row>

        <v-row class="my-2 mt-8">
          <v-btn
            :color="col[4]"
            :value="5"
            class="rounded-xl black--text text-capitalize"
            style="font-size:0.7vw;  border: 1px solid black;"
            depressed
            width="100%"
            @click="sw(4)"
            max-height="35"
          >
            <v-row>
              <v-col align="start">Студенты</v-col>
            </v-row>
          </v-btn>
        </v-row>

        <v-row class="my-2">
          <v-btn
            :color="col[5]"
            :value="6"
            class="rounded-xl black--text text-capitalize"
            style="font-size:0.7vw;  border: 1px solid black;"
            depressed
            width="100%"
            @click="sw(5)"
            max-height="35"
          >
            <v-row>
              <v-col align="start">Предприятия</v-col>
            </v-row>
          </v-btn>
        </v-row>

        <v-row class="my-2">
          <v-btn
            :color="col[6]"
            :value="7"
            class="rounded-xl black--text text-capitalize"
            style="font-size:0.7vw;  border: 1px solid black;"
            depressed
            width="100%"
            @click="sw(6)"
            max-height="35"
          >
            <v-row>
              <v-col align="start">ВУЗы</v-col>
            </v-row>
          </v-btn>
        </v-row>
      </v-col>
    </v-btn-toggle>
  </v-main>
</template>

<script>
export default {
  data: () => ({
    toggle_exclusive: undefined,
    col: ["#5B98F1", "white", "white", "white" , "white" , "white" , "white"],
  }),
  methods: {
    sw(e) {
      this.col[e] = "#5B98F1";
      for (var l = 0; l < this.col.length; l++) {
        if (l != e) {
          this.col[l] = "white";
        }
      }
    },
  },
};
</script>